import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { get_user_profile } from '../../../../app/modules/profile/api/profileApi'
const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'
type User = {
  id: number;
  department_id: string;
  department_name: string | undefined;
  title: string | undefined;
  firstname: string | undefined;
  middlename: string | undefined;
  lastname: string | undefined;
  telephone: string | undefined;
  email: string | undefined;
  password: string | undefined;
  profile_picture: string | undefined;
  mobile: string | undefined;
  picture: string | undefined;
  role: string | undefined;
  password_confirmation: string | undefined;
  status: number | undefined;
  created_at: string;
  deleted_at: string;
  updated_at: string;
};
const Navbar = () => {
  const {config} = useLayout()
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  
  const authData: any = (() => {
    const data = localStorage.getItem('kt-auth-react-v');
    try {
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error parsing kt-auth-react-v from localStorage:', error);
      return null;
    }
  })();

  // Fetch user profile from API for navbar
  const { data: profileResponse } = useQuery(
    'UserProfileForNavbar',
    get_user_profile,
    { 
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!authData?.access_token
    }
  );

  useEffect(() => {
    if (authData?.admin) {
      setCurrentUser(authData.admin);
    }
  }, []);

  // Helper function to get full profile picture URL
  const getProfilePictureUrl = (pictureUrl: string | null | undefined): string | null => {
    if (!pictureUrl) return null;
    
    // If already a full URL (starts with http:// or https://), return as is
    if (pictureUrl.startsWith('http://') || pictureUrl.startsWith('https://')) {
      return pictureUrl;
    }
    
    // Otherwise, prepend API base URL
    let baseURL = process.env.REACT_APP_API_URL || '';
    if (!baseURL) return pictureUrl;
    
    // Remove /api from the end of baseURL if present
    baseURL = baseURL.replace(/\/api\/?$/, '');
    
    // Remove trailing slash from baseURL and leading slash from pictureUrl
    const cleanBaseURL = baseURL.replace(/\/$/, '');
    const cleanPictureUrl = pictureUrl.replace(/^\//, '');
    
    return `${cleanBaseURL}/${cleanPictureUrl}`;
  };

  // Get user data - prefer API response, fallback to localStorage
  const profileData = profileResponse?.data || null;
  const localStorageAdmin = authData?.admin || null;
  
  // Priority: API response > localStorage admin
  // API now returns 'name' field instead of 'full_name'
  const userName = profileData?.name 
    || profileData?.full_name 
    || localStorageAdmin?.name
    || localStorageAdmin?.full_name 
    || localStorageAdmin?.firstname 
    || 'User';
  
  // Get user profile picture - prefer API response
  const rawProfilePicture = profileData?.profile_picture 
    || currentUser?.profile_picture 
    || localStorageAdmin?.profile_picture 
    || null;
  const userProfilePicture = getProfilePictureUrl(rawProfilePicture);

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTIcon iconName='element-plus' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          {userProfilePicture ? (
            <div
              className='symbol symbol-fixed position-relative'
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                overflow: 'hidden',
              }}
            >
              <img
                src={userProfilePicture || ''}
                alt={userName}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
                onError={(e) => {
                  // Fallback to blank image if URL fails to load
                  const target = e.target as HTMLImageElement;
                  target.src = toAbsoluteUrl('/media/avatars/blank.png');
                }}
              />
            </div>
          ) : (
            <div
              className='symbol symbol-fixed position-relative'
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                overflow: 'hidden',
              }}
            >
              <img
                src={toAbsoluteUrl('/media/avatars/blank.png')}
                alt={userName}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </div>
          )}
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export {Navbar}
